// The amber bar on every page while a superadmin is viewing the app as someone else (God's Eye → person → View as).
// Shows who, how long is left and Exit; flashes a note when the app tried to change something (blocked: read-only).
import React, { useEffect, useState } from 'react';
import { exitViewAs, viewAs } from './viewAs';

export default function ViewAsBar() {
  const [v] = useState(viewAs);
  const [now, setNow] = useState(Date.now());
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    if (!v) return undefined;
    const t = setInterval(() => setNow(Date.now()), 15000);
    const onBlocked = () => { setBlocked(true); setTimeout(() => setBlocked(false), 4000); };
    window.addEventListener('nm-read-only', onBlocked);
    return () => { clearInterval(t); window.removeEventListener('nm-read-only', onBlocked); };
  }, [v]);
  useEffect(() => {
    if (v && v.expires_at && new Date(v.expires_at).getTime() < now) exitViewAs();
  }, [v, now]);
  if (!v) return null;
  const mins = v.expires_at ? Math.max(0, Math.round((new Date(v.expires_at).getTime() - now) / 60000)) : null;
  return (
    <div role="status" style={{
      position: 'fixed', left: '50%', bottom: 16, transform: 'translateX(-50%)', zIndex: 2000, display: 'flex', alignItems: 'center', gap: 12,
      background: blocked ? '#b42318' : '#b25000', color: '#fff', borderRadius: 999, padding: '8px 10px 8px 16px', boxShadow: '0 8px 30px rgba(0,0,0,0.35)',
      font: '600 13.5px -apple-system, "SF Pro Text", "Segoe UI", Roboto, sans-serif', maxWidth: 'calc(100vw - 24px)',
    }}>
      <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {blocked ? 'Blocked: viewing is read-only' : <>Viewing as <b>{v.username}</b> · read-only{mins != null ? ` · ${mins} min left` : ''}</>}
      </span>
      <button type="button" onClick={() => exitViewAs()} style={{
        border: 0, borderRadius: 999, background: '#fff', color: '#1d1d1f', font: 'inherit', padding: '5px 12px', cursor: 'pointer',
      }}>Exit</button>
    </div>
  );
}
